import { OTHERGOODS_APPROVAL_FAILED, OTHERGOODS_APPROVAL_REQUEST, OTHERGOODS_APPROVAL_SUCCESS } from "app/redux/Approval/OtherGoodsApproval/constant";

const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const otherGoodsApprovalReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case OTHERGOODS_APPROVAL_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case OTHERGOODS_APPROVAL_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case OTHERGOODS_APPROVAL_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};